import __base_store from '@/store/__base_store'

/**
 * Store de tipos de movimiento de lote de producción (modelo `production_batch_movement_type`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'production_batch_movement_type',
	},
})

